import {
  POST_TERMS_PRIVACY_DATA,
  POST_TERMS_PRIVACY_DATA_SUCCESS,
  POST_TERMS_PRIVACY_DATA_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const postTermsPrivacyDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_TERMS_PRIVACY_DATA:
      return { ...state, loading: true };
    case POST_TERMS_PRIVACY_DATA_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case POST_TERMS_PRIVACY_DATA_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default postTermsPrivacyDataReducer;
